import React from 'react';
import { Alert, Portal, Snackbar } from '@mui/material';

export default function DashboardSnackbars({
    snackbarOpen,
    setSnackbarOpen,
    snackbarSeverity,
    snackbarMessage,
    aumSnackOpen,
    setAumSnackOpen,
    aumSnackMessage,
}) {
    return (
        <Portal>
            <Snackbar
                open={snackbarOpen}
                autoHideDuration={6000}
                onClose={() => setSnackbarOpen(false)}
            >
                <Alert
                    onClose={() => setSnackbarOpen(false)}
                    severity={snackbarSeverity}
                    sx={{ width: '100%' }}
                >
                    {snackbarMessage}
                </Alert>
            </Snackbar>

            <Snackbar
                open={aumSnackOpen}
                autoHideDuration={6000}
                onClose={() => setAumSnackOpen(false)}
                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            >
                <Alert
                    onClose={() => setAumSnackOpen(false)}
                    severity="info"
                    variant="filled"
                >
                    {aumSnackMessage}
                </Alert>
            </Snackbar>
        </Portal>
    );
}
